module.exports = __webpack_public_path__ + "img/face2.3c4cddf6.png";